import { get, post, patch, destroy } from './httpClient'

export const getPayments = (params) => get('/payment-method', params)
export const addPayment = (body) => post('/payment-method/create', body)
export const editPayment = (body, id) => patch(`/payment-method/update/${id}`, body)
export const deletePayment = (ids) => destroy('/payment-method/delete', { payment_method_id: ids })
